import { bhgCallCatalog } from "./offering-catalog";

export function getBhgCallCheckoutPricing() {
  const pricing = bhgCallCatalog.billing.pricing ?? bhgCallCatalog.manifest.pricing;
  if (!pricing) {
    throw new Error("BHG Check-in Assist pricing is not configured.");
  }
  return pricing;
}

export function getBhgCallCheckoutPlanName() {
  return bhgCallCatalog.name;
}

export function formatBillingLabel(priceCents: number, interval: "month" | "year" | "one-time") {
  const amount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: priceCents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(priceCents / 100);

  switch (interval) {
    case "month":
      return `${amount}/month`;
    case "year":
      return `${amount}/year`;
    case "one-time":
      return amount;
  }
}

export function formatCurrencyAmount(priceCents: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceCents / 100);
}
